// state
import type { RootState } from 'src/state';

import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Stack, Switch, Typography } from '@mui/material';

// hooks
import { useTranslate } from 'src/locales';
import { toggleDisplayInterval } from 'src/state/subscription/actions';

export default function SubscriptionIntervalSwitch() {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const { displayInterval } = useSelector((state: RootState) => state.subscription);

  const toggleInterval = () => {
    dispatch(toggleDisplayInterval());
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Typography variant="overline" sx={{ mr: 1.5 }}>
        {t('Monthly')}
      </Typography>
      <Switch checked={displayInterval === 'yearly'} onClick={toggleInterval} />
      <Typography variant="overline" sx={{ ml: 1.5 }}>
        {t('Yearly')} {t('(Save 2 months)')}
      </Typography>
    </Stack>
  );
}
